export default __webpack_public_path__ + "static/media/IMG_0295.5a14751c.jpeg";